import { Component, isDevMode, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WindowRef } from '../../utils/window';
import { TranslateUtil } from '../../utils/translate-util';
import { TranslateService } from '@ngx-translate/core';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';



@Component({
    selector: 'div.mbfs-full-width.internal-server-error',
    imports: [SharedTranslateModule],
    templateUrl: './internal-server-error.component.html',
    providers: []
})

export class InternalServerErrorComponent implements OnInit {
  router: Router;
  isCanadaPortal = false;
  language = '';
  brandId: string;
  usUrl: string;
  caUrl: string;
  private _window: WindowRef;
  targetRedirect = '';

  constructor(router: Router,  window: WindowRef,public translateUtil: TranslateUtil, public translate: TranslateService ) {
      this.router = router;
      this._window = window;
      this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
      this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
  }

  ngOnInit() {
    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
        this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
    });
    this.language = (this._window.nativeWindow as any).mbfs.language;

      // Set page error value for analytics
    ((window as any).mbfs).pageInfo = {pageError: '500'};
    this.buildRedirectURL();
  }


  buildRedirectURL() {
    this.brandId = sessionStorage.getItem('brandId');
    if (this.language === 'en-CA') {
      this.targetRedirect = this.caUrl + '/ca/en/home';
    } else if (this.language === 'fr-CA' && this.brandId === '3') {
      this.targetRedirect = this.caUrl + '/ca/fr/home';
    } else if (this.brandId === '3') { // If brand ID is 3 account is CA by default
      this.targetRedirect = this.caUrl + '/ca/en/home';
    } else {
      this.targetRedirect = this.usUrl + '/home';
    }
  }
}
